import React from 'react';
import { NavGridContainer } from './CategoryWidget.styles';
import { useState } from 'react';
import NavList from './Components/NavList';
import TempLabourSvg from './svgs/TempLabourSvg';
import { UploadCategoryStateContext } from 'contexts/UploadCategoryStateContext';
import { PermissionsContext } from 'contexts/PermissionsContext';
import SkuAnalysis from './SkuAnalysis/SkuAnalysis';
import { ToastMessageProvider } from 'contexts/ToastMessageContext/ToastMessageProvider';
import TempLabour from './TempLabor/TempLabour';
import Legal from './Legal/Legal';
import WorkingCapital from './WorkingCapital/WorkingCapital';
import WorkingCapitalSvg from './svgs/WorkingCapitalSvg';
import LegalSvg from './svgs/LegalSvg';
import SkuSvg from './svgs/SkuSvg';

export const categoryNav = [
	{
		key: 1,
		title: 'Temp Labor',
		icon: TempLabourSvg,
	},
	{
		key: 2,
		title: 'SKU Analysis',
		icon: SkuSvg,
	},
	{
		key: 3,
		title: 'Legal',
		icon: LegalSvg,
	},
	{
		key: 4,
		title: 'Working Capital',
		icon: WorkingCapitalSvg,
	},
];

const CategoryWidget = () => {
	const [currentContent, setCurrentContent] = useState(0);

	const getCurrentContent = key => {
		switch (key) {
			case 0:
				return (
					<NavGridContainer>
						<NavList navArray={categoryNav} setContent={setCurrentContent} />
					</NavGridContainer>
				);
			case 1:
				return <TempLabour setCurrentContent={setCurrentContent} />;
			case 2:
				return <SkuAnalysis setCurrentContent={setCurrentContent} />;
			case 3:
				return <Legal setCurrentContent={setCurrentContent} />;
			case 4:
				return <WorkingCapital setCurrentContent={setCurrentContent} />;
			default:
				break;
		}
	};
	return <>{getCurrentContent(currentContent)}</>;
};

export default props => (
	<UploadCategoryStateContext.Consumer>
		{({ categoryStatus }) => (
			<PermissionsContext.Consumer>
				{({ permissions }) => (
					<ToastMessageProvider>
						<CategoryWidget
							{...props}
							permissions={permissions || []}
							categoryFileStatus={categoryStatus}
						/>
					</ToastMessageProvider>
				)}
			</PermissionsContext.Consumer>
		)}
	</UploadCategoryStateContext.Consumer>
);
